// extracted by mini-css-extract-plugin
export var boldText = "_82-4";
export var checkboxContainer = "_82-6";
export var closeIcon = "_82-i";
export var container = "_82-0";
export var drawer = "_82-8";
export var drawerContent = "_82-9";
export var extraSmallText = "_82-5";
export var fulfillmentGroupTable = "_82-e";
export var largeText = "_82-3";
export var loadingSpinnerContainer = "_82-j";
export var mediumText = "_82-2";
export var narrow = "_82-f";
export var notificationLink = "_82-l";
export var packageCheckIconContainer = "_82-7";
export var slideoutHeaderActions = "_82-g";
export var slideoutHeaderActionsShifted = "_82-h";
export var slideoutHeaderContainer = "_82-a";
export var slideoutModal = "_82-c";
export var stickyHeaderWrapper = "_82-b";
export var table = "_82-k";
export var tableContainer = "_82-d";
export var tertiaryText = "_82-1";